import { VehicleIAMPartCategoryTreeItem } from '@1po/1po-bff-fe-spec/generated/catalog/category/model/VehicleIAMPartCategoryTreeItem';
import { VehiclePartCategoryTreeItem } from '@1po/1po-bff-fe-spec/generated/catalog/category/model/VehiclePartCategoryTreeItem';
import { TreeType } from 'components/TreeMenu/TreeMenu';

const handleLvl3Items = (lvl3Items?: VehicleIAMPartCategoryTreeItem[]) => {
  return (
    lvl3Items?.map((lvl3: VehicleIAMPartCategoryTreeItem | VehiclePartCategoryTreeItem) => {
      return {
        nodeId: lvl3.nodeId,
        label: lvl3.label,
        hasOperations: 'operationIds' in lvl3 && lvl3.operationIds?.length > 0,
        childCategories: [],
      };
    }) ?? []
  );
};

const handleLvl2Items = (lvl2Items?: VehicleIAMPartCategoryTreeItem[] | VehiclePartCategoryTreeItem[]) => {
  return (
    lvl2Items?.map((lvl2: VehicleIAMPartCategoryTreeItem | VehiclePartCategoryTreeItem) => {
      return {
        nodeId: lvl2.nodeId,
        label: lvl2.label,
        hasOperations: 'operationIds' in lvl2 && lvl2.operationIds?.length > 0,
        childCategories: handleLvl3Items(lvl2.items),
      };
    }) ?? []
  );
};

const handleLvl1Items = (lvl1Items?: VehicleIAMPartCategoryTreeItem[]) => {
  return (
    lvl1Items?.map((lvl1: VehicleIAMPartCategoryTreeItem) => {
      return {
        nodeId: lvl1.nodeId,
        label: lvl1.label,
        childCategories: handleLvl2Items(lvl1.items),
      };
    }) ?? []
  );
};

export const getTree = (treeData: VehicleIAMPartCategoryTreeItem[] | undefined): TreeType[] =>
  handleLvl1Items(treeData);
